import { TooltippedIconButton, useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconButtonProps } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { useNavigateToSubscriptions } from '../hooks';

export type DeleteButtonButtonProps = { entityName: string; deleteAction: () => Promise<void> } & Pick<
    IconButtonProps,
    'size' | 'variant'
>;

export const DeleteButton = ({ deleteAction, entityName }: DeleteButtonButtonProps) => {
    const { navigateToSubscriptions } = useNavigateToSubscriptions();

    const handleDelete = async () => {
        await deleteAction();
        navigateToSubscriptions();
    };

    const { openConfirmationDialog, confirmationDialog } = useDeleteConfirmationDialog({
        title: lt('DeleteConfirmation', { entity: entityName }),
        renderContent: () => lt('DeleteHint'),
        deleteAction: handleDelete,
    });

    return (
        <>
            <TooltippedIconButton
                tooltip={lt(TextKey.Delete)}
                icon={IconName.Delete}
                type="button"
                onClick={openConfirmationDialog}
            />
            {confirmationDialog}
        </>
    );
};
